import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { EventService } from '../event/event.service';

export const eventInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  request = request.clone({
    setHeaders: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'X-Event': inject(EventService).getSelectedEvent()?.uuid ?? '',
    },
  });

  return next(request);
};
